module.exports = __webpack_public_path__ + "img/bmw-600x279.2a57fb61.png";